module.exports = __webpack_public_path__ + "media/icons/checked-56a18f63.png";